import BilledBillables from "@/modules/reports/billables/status/billed";
import CancelledBillables from "@/modules/reports/billables/status/cancelled";
import CollectedBillables from "@/modules/reports/billables/status/collected";
import ContractedBillables from "@/modules/reports/billables/status/contracted";
import NavSlot from "@/components/navigation/links";
import { Outlet } from "react-router-dom";
import PendingBillables from "@/modules/reports/billables/status/pending_invoice";
import AllBillables from "@/modules/reports/billables/status/all";

export const billableStatus = [
  {
    label: "Contracted",
    value: "contracted",
    path: "/reports/billables/status/contracted",
    element: ContractedBillables,
  },
  {
    label: "Pending Invoice",
    value: "pending_invoice",
    path: "/reports/billables/status/pending_invoice",
    element: PendingBillables,
  },
  {
    label: "Billed",
    value: "billed",
    path: "/reports/billables/status/billed",
    element: BilledBillables,
  },
  {
    label: "Collected",
    value: "collected",
    path: "/reports/billables/status/collected",
    element: CollectedBillables,
  },
  {
    label: "Cancelled",
    value: "cancelled",
    path: "/reports/billables/status/cancelled",
    element: CancelledBillables,
  },
  {
    label: "All",
    value: "all",
    path: "/reports/billables/status/all",
    element: AllBillables,
  },
];

const StatusLayout = () => {
  return (
    <div className="flex-1 overflow-auto relative">
      <div className="sticky  w-full bg-white z-10">
        <NavSlot navItems={billableStatus} />
      </div>
      <Outlet />
    </div>
  );
};

export default StatusLayout;
